var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCapterra = function SvgCapterra(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 91.919L105.906 91.9398L169.087 91.9505V29.4927L2 91.919Z",
    fill: "#FF9D28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.087 29.4925V250L247.999 0L169.087 29.4925Z",
    fill: "#68C5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.088 91.9482L105.906 91.9375L169.088 249.998V91.9482Z",
    fill: "#044D80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 91.917L122.108 132.494L105.906 91.9377L2 91.917Z",
    fill: "#E54747"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCapterra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/capterra.0b68ff7b.svg";
export { ForwardRef as ReactComponent };